export const getMainCameraElement = () => {
  const videoContainer: HTMLElement = document.getElementById("video")
  const videoElement: HTMLVideoElement = videoContainer?.querySelector("video")

  return videoElement
}
